export default {
  methods: {
    // { "responseWallsCeilingFloorHeatTransfer": 1.453, "responseHeatTransmission": 10.98, "responseHeatRadiation": 7.04, "responseHeatDevices": 40, "responseFreshAirHeatGain": 0.22, "responseAirFlowInfiltration": 29.83, "responseCondensateWater": 0.11, "responseHeatCalculated": 58.24, "responseTotalHeatGain": 64.07, "responseAdditionalHumidityRequired": 27.01, "responseSafetyFactor": 10, "responseAirFlow": 0, "createdDate": "2025-02-19T15:00:07.235514", "updatedDate": "2025-02-19T15:00:07.235585", "isActive": true }
    getExcelFields() {
      return {
        [this.$t("ehouseCalculating.title")]: {
          field: "title",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.pvcThickness")]: {
          field: "requestPvcThickness",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.pvcThermalConductivity")]: {
          field: "requestPvcThermalConductivity",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.noneMaterialThickness")]: {
          field: "requestNoneMaterialThickness",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.noneMaterialThermalConductivity")]: {
          field: "requestNoneMaterialThermalConductivity",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.steelPlateThickness")]: {
          field: "requestSteelPlateThickness",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.steelPlateThermalConductivity")]: {
          field: "requestSteelPlateThermalConductivity",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.asbestosThickness")]: {
          field: "requestAsbestosThickness",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.asbestosThermalConductivity")]: {
          field: "requestAsbestosThermalConductivity",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.airTemperature")]: {
          field: "requestAirTemperature",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.relativeHumidity")]: {
          field: "requestRelativeHumidity",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.heatGeneration")]: {
          field: "requestHeatGeneration",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.requiredPressurization")]: {
          field: "requestRequiredPressurization",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.requiredPressurizationStandard")]: {
          field: "requestRequiredPressurizationStandard",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.locationFactor")]: {
          field: "requestLocationFactor",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.atmosphericPressure")]: {
          field: "requestAtmosphericPressure",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.ambientTemperature")]: {
          field: "requestAmbientTemperature",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.ambientHumidity")]: {
          field: "requestAmbientHumidity",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.radiationPower")]: {
          field: "requestRadiationPower",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.length")]: {
          field: "requestLength",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.width")]: {
          field: "requestWidth",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.height")]: {
          field: "requestHeight",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.numberOfDoors")]: {
          field: "requestNumberOfDoors",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.electricalInletOutlet")]: {
          field: "requestElectricalInletOutlet",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.wallsCeilingFloorHeatTransfer")]: {
          field: "responseWallsCeilingFloorHeatTransfer",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.heatTransmission")]: {
          field: "responseHeatTransmission",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.heatRadiation")]: {
          field: "responseHeatRadiation",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.heatDevices")]: {
          field: "responseHeatDevices",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.freshAirHeatGain")]: {
          field: "responseFreshAirHeatGain",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.airFlowInfiltration")]: {
          field: "responseAirFlowInfiltration",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.condensateWater")]: {
          field: "responseCondensateWater",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.heatCalculated")]: {
          field: "responseHeatCalculated",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.totalHeatGain")]: {
          field: "responseTotalHeatGain",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.additionalHumidityRequired")]: {
          field: "responseAdditionalHumidityRequired",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.safetyFactor")]: {
          field: "responseSafetyFactor",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("ehouseCalculating.airFlow")]: {
          field: "responseAirFlow",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("common.createdDate")]: {
          field: "createdDate",
          callback: (value) => {
            return this.$date.format(value);
          },
        },
        [this.$t("common.isActive")]: {
          field: "isActive",
          callback: (value) => {
            return value ? this.$t("common.active") : this.$t("common.passive");
          },
        },
        [this.$t("common.userInfo")]: {
          field: "user.fullname",
          callback: (value) => {
            return value;
          },
        },
      };
    },
  },
};
